module.exports = __webpack_public_path__ + "img/AccuIMR.e9163f4c.png";